import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Loader from '../../../components/Loader';
import axios from 'axios';
import params from '../../../config/Params';
import { getItemFromLocalStorage } from '../../../utils/storageUtils';
import { toast } from 'react-toastify';

const PayoutMethod = ({ formData, setFormData }) => {
    const [loading, setLoading] = useState(true);
    const [baseData, setBaseData] = useState([]);

    useEffect(() => {
        const fetchBaseData = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.payoutBaseData}`,
                    data: formData
                });

                if (response.data.status === 'found') {
                    setBaseData(response.data.payment_methods);
                } else {
                    toast.error('An error occurred while fetching payout methods.');
                }
            } catch (err) {
                toast.error(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBaseData();
    }, []);

    const handleMethodChange = (id) => {
        setFormData(prev => ({
            ...prev,
            payout_method_id: id
        }));
    };

    return (
        <div>
            <Helmet>
                <title>Add Payment Method</title>
                <meta name='description' content='' />
            </Helmet>

            <div className="payout-setup">
                <div className='ws-cl-header'>
                    <div>
                        <h4 className='ws-title'>Update Payout Preferences</h4>
                        <p className='ws-desc'>Receive your earnings in 5-7 business days.</p>
                    </div>
                </div>

                {loading ? (
                    <Loader />
                ) : baseData.length > 0 ? (
                    <div className="payment-options">
                        {baseData.map((method) => (
                            <div className={`po-form-box ${formData.payout_method_id === method.id ? 'selected' : ''}`} key={method.id}>
                                <div className='form-flex form-icon-box'>
                                    <div className='form-icon'>
                                        <img 
                                        src='/assets/img/icons/pointer_icon.svg'
                                        className='form-icon img-fluid'
                                        alt=''
                                        />
                                    </div>
                                    <div className='form-txt drawer-policy-box mb-0'>
                                        <label className='policy-radio-input'>
                                            <div className='policy-radio-txt-box'>
                                                <span>
                                                    <div>{method.title}</div>
                                                </span>
                                            </div>
                                            <div className="circle"></div>
                                            <input
                                                type="radio"
                                                name="payment_method"
                                                value={method.id}
                                                checked={formData.payout_method_id === method.id}
                                                onChange={() => handleMethodChange(method.id)}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No payout methods available at the moment.</p>
                )}
            </div>
        </div>
    );
};

export default PayoutMethod;
